import parse from 'html-react-parser';

export default function StatCard({blockInfo}) {
    return (
        <div 
            className="pt-12 sm:pt-16" 
            style={{backgroundColor: blockInfo?.backgroundColorTop ?? 'bg-gray-50'}}
        >
            <div className="mx-auto max-w-7xl px-6 lg:px-8">
                <div className="mx-auto max-w-4xl text-center">
                    <h2 className="text-3xl font-bold tracking-tight sm:text-4xl" style={{color: blockInfo?.textColor ?? 'white'}}>
                        {blockInfo?.headline}
                    </h2>
                    <div className='text-xl' style={{color: blockInfo?.textColor ?? 'white'}}>
                        {parse(blockInfo?.text ?? '')}
                    </div>
                </div>
            </div>
            <div 
                className="mt-10 bg-white pb-12 sm:pb-16" 
                style={{backgroundColor: blockInfo?.backgroundColorBottom ?? 'bg-white'}}
            >
                <div className="relative">
                    <div 
                        className="absolute inset-0 h-1/2" 
                        style={{backgroundColor: blockInfo?.backgroundColorTop ?? 'bg-gray-50'}}
                    />
                    <div className="relative mx-auto max-w-7xl px-6 lg:px-8">
                        <div className="mx-auto max-w-4xl">
                            <div className="rounded-lg bg-white shadow-lg sm:grid sm:grid-cols-3">
                                <div className="flex flex-col border-0 border-b border-solid border-gray-100 p-6 text-center sm:border-0 sm:border-r">
                                    <div className="order-2 mt-2 text-lg font-medium leading-6 text-gray-500">
                                        {blockInfo?.stat1description}
                                    </div>
                                    <div className="order-1 text-5xl font-bold tracking-tight text-primary-500">
                                        {blockInfo?.stat1}
                                    </div>
                                </div>
                                <div className="flex flex-col border-0 border-solid border-b border-gray-100 p-6 text-center sm:border-0 sm:border-r">
                                    <div className="order-2 mt-2 text-lg font-medium leading-6 text-gray-500">
                                        {blockInfo?.stat2description}
                                    </div>
                                    <div className="order-1 text-5xl font-bold tracking-tight text-primary-500">
                                        {blockInfo?.stat2}
                                    </div>
                                </div>
                                <div className="flex flex-col border-t border-gray-100 p-6 text-center sm:border-0 sm:border-l">
                                    <div className="order-2 mt-2 text-lg font-medium leading-6 text-gray-500">
                                        {blockInfo?.stat3description}
                                    </div>
                                    <div className="order-1 text-5xl font-bold tracking-tight text-primary-500">
                                        {blockInfo?.stat3}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
